/**
 * oraScritta.js — un'ora italiana scritta com'e', letta com'e' scritta.
 *
 * Due colonne del database tengono l'ora italiana in un timestamp SENZA fuso:
 * la scadenza dei compiti (compiti.scadenza) e l'ora dei promemoria
 * (alert.data_ora, dal 21/10/2026 anche per gli avvisi che scrive il sistema).
 * Il server gira in UTC, e node-pg le manda in JSON con la Z, come se fossero
 * UTC: una scadenza alle 23:00 arriva «...T23:00:00.000Z», e new Date() in un
 * browser in Italia la spostava avanti di due ore d'estate e di una d'inverno
 * («domani alle 01:00»). Qui il fuso si toglie e le cifre si leggono come ora
 * locale. Una funzione sola per tutte e due (Alex, 21/10: «Non due correzioni
 * diverse per lo stesso difetto»).
 *
 * Non vale per le colonne scritte in UTC (appuntamenti.inizio, created_at...):
 * quelle si leggono con new Date(), e il fuso che portano e' giusto.
 *
 * Prova: src/utils/oraScritta.test.js e le pagine che la usano, con
 * npm run ora-scritta (TZ=Europe/Rome), dentro npm run rilascia.
 */
export const oraScritta = (d) => {
    if (d === null || d === undefined || d === '') return null;
    return new Date(String(d).replace(/(\.\d+)?(Z|[+-]\d\d:?\d\d)$/, ''));
};
